<template>
  <div class="container">
    <div class="container__left">
      <LeftBar></LeftBar>
    </div>

    <div class="container__right">
      <TopBar></TopBar>
      <div class="container__right__content">
        <slot name="title"></slot>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import LeftBar from '@/components/LeftBar'
import TopBar from '@/components/TopBar'

export default {
  name: 'Layout',
  components: {
    LeftBar,
    TopBar
  }
}
</script>

<style>
.container {
  display: flex;
  flex-direction: row;
}

.container__left {
  position: fixed;
  width: 220px;
}

.container__right {
  align-items: center;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 220px;
  position: relative;
  width: calc(100% - 220px);
}

.container__right__content {
  align-items: flex-start;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  max-width: 1024px;
  min-height: calc(100vh - 60px);
  padding: 40px 50px 0 50px;
  width: 100%;
}

.container__right__content > h1 {
  color: #00535e;
  font-weight: 100;
  text-align: left;
}
</style>
